import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { reset } from "redux-form";
import dasherize from "underscore.string/dasherize";
//actions
import { actions, clearDetail } from "actions/resources";
import { searchCompanies } from "actions/search";
//components
import ClientForm from "./forms/client";
import { Col, Row } from "antd";
//images
import defaultClientImage from "images/default_profile.jpg";

import { clientsIndex } from "../../../utils/algolia";
//utils

import { uploadPhoto } from "utils/image";
import { ImageUploader } from "../../../components/generic/ImageUploader";

export class EditClient extends Component {
    state = {
        imageDataUrl: null
    };

    constructor(props) {
        super(props);
        this.clientPictureRef = React.createRef();
    }

    componentWillMount() {
        this._fetchDependencies();
    }

    componentWillUnmount() {
        this.props.clearDetail('client');
        this.props.resetForm('client-edit');
    }

    _fetchDependencies = async () => {
        const { fetchClient, searchCompanies, match } = this.props;
        if (match.params.id) {
            await fetchClient(match.params.id);
            searchCompanies();
        }
    };

    _processPayload = async (data, extraParams = {}) => {
        let payload = {
            ...{
                status: data.status,
                first_name: data.first_name,
                last_name: data.last_name,
                title: data.title,
                phone: data.phone,
                email: data.email,
                company_id: data.company_id,
                linkedin_url: data.linkedin_url,
                interests: JSON.stringify(data.interests)
            },
            ...extraParams
        };

        return new Promise((resolve, reject) => {
            if (this.clientPictureRef.current && this.clientPictureRef.current.getImageAsDataUrl().length > 0) {

                let fileKey = `client-pictures/${dasherize(data.id)}`;

                let imageData = {
                    fileKey: fileKey,
                    image: this.clientPictureRef.current.getImageAsDataUrl()
                };

                uploadPhoto(imageData).then((value) => {
                    payload = {
                        ...payload,
                        ...{ image: `https://assets.wesolv.com/${imageData.fileKey}` }
                    };
                    resolve(payload);
                });
            } else {
                resolve(payload);
            }
        });
    };

    onImageUpdate = (data) => {
        this.setState({
            imageDataUrl: data
        });
    };

    _updateClient = async data => {
        const { match, updateClient, redirect } = this.props;
        await this._processPayload(data);
        this._processPayload(data).then(async (result) => {
            const response = await updateClient(match.params.id, result);
            if (response) {
                clientsIndex.waitTask(response.payload.algoliaTaskID, () => {
                    redirect(`/companies`);
                });
            }
        });
    };

    _deleteCompanyUser = async data => {
        const { client, deleteClient, redirect } = this.props;

        // console.log("delete client", client.id);
        
        await deleteClient(client.id);
        
        redirect(`/companies/edit/${client.company_id}`);
    };

    render() {
        const { client, companiesAlgolia, searchCompanies } = this.props;

        if (client && companiesAlgolia && companiesAlgolia.hits) {
            let companyOptions = companiesAlgolia.hits.map(company => { return { text: company.name, value: company.objectID } });
            companyOptions.push({ text: client.company_name, value: client.company_id });
            const clientImage = (client && client.image) || defaultClientImage;
            return (
                <Row className="detail-spacer">
                    <Row>
                        <Col span={24}>
                            <Row>
                                <Col type="flex" justify="center" align="middle">
                                    <h1 id="header">Edit User: {client.first_name} {client.last_name}</h1>
                                </Col>
                            </Row>
                            <br />
                            <Row type="flex" justify="center">
                                <ImageUploader
                                    currentImage={clientImage}
                                    ImageRef={this.clientPictureRef} />
                            </Row>
                            <br />
                            <Row type="flex" justify="center">
                                <Col span={20}>
                                    <ClientForm
                                        initialValues={client}
                                        onSubmit={this._updateClient}
                                        deleteCompanyUser={this._deleteCompanyUser}
                                        backToCompany={() => this.props.redirect(`/companies/edit/${client.company_id}`)}
                                        companies={companyOptions}
                                        searchCompanies={searchCompanies}
                                    />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Row>
            );
        } else {
            return null;
        }
    }
}

export default connect(
    state => ({
        companiesAlgolia: state.search.companiesAlgolia,
        client: state.resources.detail.client || null,
    }),
    dispatch => ({
        searchCompanies: bindActionCreators(searchCompanies, dispatch),
        fetchClient: bindActionCreators(actions.fetchClient, dispatch),
        redirect: bindActionCreators(push, dispatch),
        updateClient: bindActionCreators(actions.patchClient, dispatch),
        deleteClient: bindActionCreators(actions.deleteClient, dispatch),
        resetForm: bindActionCreators(reset, dispatch),
        clearDetail: bindActionCreators(clearDetail, dispatch)
    })
)(EditClient);



// WEBPACK FOOTER //
// ./src/components/dashboard/company/client.js